import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "@phosphor-icons/react";

const STORAGE_KEY = "freightpilot_cookie_consent_v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const existing = localStorage.getItem(STORAGE_KEY);
      if (!existing) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const record = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        choice, // "accepted" | "essential_only"
        at: new Date().toISOString(),
      }));
    } catch {}
    setVisible(false);
    window.dispatchEvent(new Event("fp:cookie-consent"));
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 right-4 max-w-[calc(100vw-2rem)] w-80 sm:right-6 sm:bottom-6 sm:w-96 sm:max-w-md z-[70]"
    >
      <div className="card-surface bg-[#0A0A0A]/95 backdrop-blur-md border border-white/10 rounded-2xl p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="shrink-0 w-9 h-9 rounded-full bg-[#FF5A1F]/15 text-[#FF5A1F] flex items-center justify-center">
            <Cookie size={18} weight="fill" />
          </div>
          <div className="flex-1">
            <div className="text-white font-semibold text-sm mb-1">Cookies & tracking</div>
            <p className="text-neutral-400 text-xs leading-relaxed">
              We use essential cookies to keep you signed in, and analytics cookies (Meta Pixel, Google) to improve
              the site and measure ad performance. See our{" "}
              <Link to="/privacy" className="text-[#FF5A1F] hover:text-[#FF7038] underline">Privacy Policy</Link>.
            </p>
          </div>
          <button
            aria-label="Dismiss cookie banner (essential only)"
            data-testid="cookie-consent-dismiss"
            onClick={() => record("essential_only")}
            className="shrink-0 -mt-1 -mr-1 p-1 text-neutral-500 hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
        </div>
        <div className="mt-4 flex flex-col-reverse sm:flex-row gap-2">
          <button
            onClick={() => record("essential_only")}
            data-testid="cookie-consent-essential"
            className="flex-1 rounded-full px-4 py-2 text-xs font-medium border border-white/15 text-neutral-200 hover:text-white hover:border-white/30 transition-colors"
          >
            Essential only
          </button>
          <button
            onClick={() => record("accepted")}
            data-testid="cookie-consent-accept"
            className="flex-1 rounded-full px-4 py-2 text-xs font-semibold bg-[#FF5A1F] text-black hover:bg-[#FF7038] transition-colors"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
